import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

export const tryNumberConvert = value => {
  return (/^\d+$/.test(value)) ? Number(value) : value;
};

export function unpackFromUrl({ propertyType, query, filterGroup, sort, setProperties, filters }) {
  const queryFilters = query[`${propertyType}:filters`];
  const queryFiltersMap = queryFilters ? new Map(JSON.parse(queryFilters)) : new Map();
  Object.keys(filterGroup).forEach(filter => {
    if (queryFiltersMap.has(filter)) {
      filters.set(filter, queryFiltersMap.get(filter));
    }
  });

  const querySort = query[`${propertyType}:sort`];
  const updatedSort = querySort ? querySort.split(':') : sort;
  setProperties(filters, updatedSort);
}

export default function withAppliedFilters(WrappedComponent) {
  class AppliedFilterWrapper extends Component {
    componentWillMount() {
      const {
        filterGroup,
        filters,
        propertyType,
        fetched,
        setProperties,
        location: { search },
        sort,
      } = this.props;
      if (!fetched) {
        const query = queryString.parse(search);
        unpackFromUrl({ propertyType, query, filterGroup, filters, sort, setProperties });
      }
    }

    componentDidUpdate(prevProps) {
      const { propertyType: prevType, organizationId: prevId } = prevProps;
      const {
        filterGroup,
        filters,
        propertyType,
        fetched,
        setProperties,
        location: { search },
        organizationId,
        sort,
      } = this.props;
      const shouldFetch = prevType !== propertyType || prevId !== organizationId;

      if (shouldFetch && !fetched) {
        const query = queryString.parse(search);
        unpackFromUrl({ propertyType, query, filterGroup, filters, sort, setProperties });
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
        />
      );
    }
  }

  AppliedFilterWrapper.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
    filters: PropTypes.object,
    setProperties: PropTypes.func,
    fetched: PropTypes.bool.isRequired,
    organizationId: PropTypes.string,
    sort: PropTypes.arrayOf(PropTypes.string).isRequired,
    propertyType: PropTypes.string.isRequired,
    filterGroup: PropTypes.object.isRequired,
  };

  return AppliedFilterWrapper;
}



// WEBPACK FOOTER //
// ./src/components/Filter/WithAppliedFilters.js